import React from 'react'
import { IconSizeType } from './PersonalTouch'

export const HandWritten: React.FC<IconSizeType> = ({
  width = 48,
  height = 48,
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_425_17011)">
        <rect
          x={4}
          y={4}
          width={40}
          height={40}
          rx={4}
          fill="white"
          shapeRendering="crispEdges"
        />
        <path
          d="M17.0066 26.7715C17.0266 26.6916 17.0366 26.6317 17.0366 26.5918C17.0366 26.5518 17.0166 26.5318 16.9767 26.5318C16.9567 26.5318 16.8968 26.5818 16.7969 26.6816C16.717 26.7815 16.6071 26.9213 16.4673 27.1011C16.3275 27.2809 16.0279 27.6205 15.5684 28.1199C15.129 28.6192 14.6696 29.0886 14.1902 29.5281C12.8918 30.7665 11.5934 31.7154 10.295 32.3745C9.97544 32.5343 9.62587 32.6142 9.24635 32.6142C7.78817 32.6142 7.05908 31.5156 7.05908 29.3184C7.05908 27.3608 7.98792 25.0037 9.8456 22.2472C10.7245 20.9688 11.7732 19.7203 12.9917 18.5019C14.2301 17.2634 15.5385 16.1648 16.9168 15.206C18.295 14.2472 19.7932 13.4782 21.4111 12.8989C23.0291 12.2996 24.6071 12 26.1452 12C26.4049 12 26.7545 12.0899 27.1939 12.2697C27.933 12.5893 28.3025 12.9288 28.3025 13.2884C28.3025 13.4881 28.1727 13.598 27.913 13.618C27.8131 13.618 27.7632 13.6579 27.7632 13.7378C27.7632 13.8177 27.903 13.9775 28.1827 14.2172C28.4823 14.437 28.6321 14.6567 28.6321 14.8764C28.6321 15.0762 28.5622 15.2559 28.4224 15.4157C27.4236 16.5144 26.6246 17.4332 26.0254 18.1723C25.4261 18.8914 24.9667 19.4307 24.6471 19.7903C24.3475 20.1498 23.9979 20.5693 23.5984 21.0487C23.2189 21.5081 22.7894 22.0974 22.31 22.8165C21.8306 23.5156 21.3912 24.2147 20.9917 24.9139C20.0728 26.6117 19.6134 28.1698 19.6134 29.588C19.6134 30.9863 19.7432 32.3146 20.0029 33.573C20.2626 34.8514 20.5322 35.6305 20.8119 35.9101C20.8119 35.97 20.742 36 20.6022 36C19.6833 36 18.8943 35.6404 18.2351 34.9213C17.0366 33.583 16.4374 31.8252 16.4374 29.6479C16.4374 28.8689 16.6271 27.9101 17.0066 26.7715ZM20.9317 20.03L26.6845 14.2472C26.8244 14.1074 26.8943 14.0075 26.8943 13.9476C26.8943 13.8876 26.8443 13.8577 26.7445 13.8577C25.2064 14.0974 23.5784 14.7266 21.8606 15.7453C20.1427 16.764 18.5847 17.9426 17.1864 19.2809C15.7882 20.6192 14.4998 21.9875 13.3213 23.3858C12.1427 24.784 11.2239 26.0424 10.5647 27.161C9.9255 28.2796 9.6059 29.0787 9.6059 29.5581C9.6059 29.638 9.65584 29.6779 9.75571 29.6779C9.87556 29.6779 10.0953 29.608 10.4149 29.4682C10.7345 29.3084 11.8331 28.4295 13.7108 26.8315C15.6084 25.2135 18.0154 22.9463 20.9317 20.03Z"
          fill="#D8B330"
        />
        <path
          opacity={0.6}
          d="M28.5366 27.7454L28.7763 25.8278C28.7763 25.7678 28.7564 25.7379 28.7164 25.7379C28.6964 25.7379 28.6465 25.7778 28.5666 25.8577C28.3069 26.1374 27.9773 26.4869 27.5778 26.9064C27.1783 27.3059 26.4892 27.8552 25.5104 28.5543C24.5516 29.2335 23.7726 29.5731 23.1733 29.5731C23.0735 29.5531 22.9536 29.5131 22.8138 29.4532C22.654 29.4133 22.4542 29.2535 22.2145 28.9738C21.9748 28.6942 21.855 28.2947 21.855 27.7753C21.855 27.256 22.2545 26.467 23.0535 25.4083C23.8325 24.3296 24.7713 23.2809 25.87 22.2622C26.9686 21.2235 28.1871 20.3246 29.5254 19.5656C30.8837 18.8065 32.0622 18.427 33.061 18.427C33.4405 18.447 33.7401 18.7166 33.9598 19.236C34.1596 19.0362 34.3394 18.9364 34.4992 18.9364C34.659 18.9364 34.8487 19.0562 35.0685 19.2959C35.1883 19.3159 35.3082 19.3858 35.428 19.5057C35.5479 19.6055 35.6078 19.7553 35.6078 19.9551C35.6078 20.1548 35.468 20.3746 35.1883 20.6143C34.7688 21.1336 34.2794 21.7229 33.7201 22.3821C33.1608 23.0412 32.7613 23.5206 32.5216 23.8203C32.2819 24.0999 32.0323 24.4195 31.7726 24.7791C31.3331 25.3983 31.0934 25.8977 31.0535 26.2772C33.0909 25.2984 36.2969 23.191 40.6715 19.9551C40.8512 20.0949 40.9411 20.2647 40.9411 20.4645C40.9411 20.6642 40.8612 20.834 40.7014 20.9738C40.5416 21.1136 40.3419 21.2834 40.1022 21.4832C39.8824 21.6829 39.433 22.0724 38.7539 22.6517C38.0747 23.231 37.4155 23.7903 36.7763 24.3296C36.1571 24.849 35.438 25.4382 34.619 26.0974C33.82 26.7366 33.1009 27.2859 32.4617 27.7454C30.9236 28.844 29.9648 29.3933 29.5853 29.3933C29.2058 29.3933 28.9361 29.2734 28.7763 29.0337C28.6165 28.794 28.5366 28.3646 28.5366 27.7454ZM25.4804 26.4869C25.7201 26.4869 26.4492 25.9975 27.6677 25.0188C28.9062 24.04 30.0747 23.0612 31.1733 22.0824L32.8512 20.6143C32.9311 20.5344 32.9711 20.4844 32.9711 20.4645C32.9711 20.4245 32.9411 20.4045 32.8812 20.4045C32.1221 20.4045 31.1334 20.844 29.9149 21.7229C28.6964 22.5818 27.6378 23.5007 26.7389 24.4794C25.86 25.4382 25.4205 26.0874 25.4205 26.427C25.4205 26.467 25.4405 26.4869 25.4804 26.4869Z"
          fill="#D8B330"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_425_17011"
          x={0}
          y={0}
          width={48}
          height={48}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation={2} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_425_17011"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_425_17011"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  )
}
